var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 8.63636,
    stroke: "#979797",
    strokeWidth: 0.727273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09589 5.78809H8.91718C9.65937 5.78809 10.1997 5.93294 10.5383 6.22266C10.8768 6.50911 11.0461 6.96647 11.0461 7.59473C11.0461 8.00814 10.9566 8.35482 10.7775 8.63477C10.5985 8.91146 10.3544 9.0791 10.0451 9.1377V9.18652C10.4488 9.28743 10.7401 9.47624 10.9191 9.75293C11.0982 10.0296 11.1877 10.3975 11.1877 10.8564C11.1877 11.5042 11.0135 12.012 10.6652 12.3799C10.3202 12.7445 9.84654 12.9268 9.24433 12.9268H7.09589V5.78809ZM8.34589 8.65918H8.95624C9.23619 8.65918 9.43313 8.58431 9.54706 8.43457C9.661 8.28483 9.71796 8.06185 9.71796 7.76562C9.71796 7.4694 9.65286 7.25781 9.52265 7.13086C9.39244 7.00065 9.18736 6.93555 8.90741 6.93555H8.34589V8.65918ZM8.34589 9.76758V11.7646H9.01484C9.29153 11.7646 9.49661 11.68 9.63007 11.5107C9.76679 11.3415 9.83515 11.0794 9.83515 10.7246C9.83515 10.0866 9.5552 9.76758 8.99531 9.76758H8.34589Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.50b13b0fba8a541cfd5124a6ec249444.svg";
export { ForwardRef as ReactComponent };